import { combineReducers } from 'redux';
import { offersReducer } from './offers';
import { detailsReducer } from './details';

export default combineReducers({
	offers: offersReducer,
	details: detailsReducer,
});
